import { render, staticRenderFns } from "./MemberPopEdit.vue?vue&type=template&id=640be313&"
import script from "./MemberPopEdit.vue?vue&type=script&lang=js&"
export * from "./MemberPopEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports